import { HTMLAttributes } from 'react'
import { map } from 'lodash'

import { cn } from '@/lib/utils'

export type CarouselDotsProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    count?: number
    selectedIndex?: number
  }>

const CarouselDots = ({ className, count = 0, selectedIndex = 0, ...props }: CarouselDotsProps) => {
  return (
    <div className={cn('flex items-center justify-center', className)} {...props}>
      {map(Array.from({ length: count }), (_, index) => (
        <div
          key={`gallery-dot-${index}`}
          style={{ left: `${-1.6 * selectedIndex + 0.8 * (count - 1)}rem` }}
          className={cn(
            'relative',
            'transition-all duration-300 ease-out-cubic',
            'mx-[0.4rem] h-[0.8rem] w-[0.8rem] scale-0 rounded-full bg-dark',
            {
              'scale-[1]': index === selectedIndex,
              'scale-[0.6]': index === selectedIndex - 1 || index === selectedIndex + 1,
              'scale-[0.3]': index === selectedIndex - 2 || index === selectedIndex + 2
            }
          )}
        />
      ))}
    </div>
  )
}

export default CarouselDots
